const SUPPORTED_PROVIDERS = {
  INJECTED: 'INJECTED',
  WALLETCONNECT: 'WALLETCONNECT',
}


export default SUPPORTED_PROVIDERS